"use client";

import { ComingSoonTool } from "@/components/tools/coming-soon-tool";
import { CurlTranslatorTool } from "@/components/tools/implementations/curl-tool";
import {
  Base64Tool,
  ColorConverterTool,
  HashGeneratorTool,
  HtmlEscapeTool,
  JsonTool,
  JwtDecoderTool,
  PasswordGeneratorTool,
  UrlEncoderTool,
  UrlParserTool,
  UuidGeneratorTool,
} from "@/components/tools/implementations/developer-tools";
import { TimestampConverterTool } from "@/components/tools/implementations/timestamp-tool";
import {
  CaseConverterTool,
  CsvToMarkdownTool,
  SlugGeneratorTool,
  TextDiffTool,
  TextStatisticsTool,
} from "@/components/tools/implementations/text-tools";
import {
  MetaTagGeneratorTool,
  OpenGraphPreviewTool,
  RobotsGeneratorTool,
  UtmBuilderTool,
} from "@/components/tools/implementations/seo-tools";
import {
  ImageMetadataStripperTool,
  ImageResizeTool,
  SvgToImageTool,
} from "@/components/tools/implementations/image-tools";
import {
  HeadersCheckerTool,
  SecurityHeadersAuditorTool,
} from "@/components/tools/implementations/network-tools";
import { RedirectChainCheckerTool } from "@/components/tools/implementations/redirect-tracker-tool";
import {
  PdfCompressTool,
  PdfMergeTool,
  PdfSplitTool,
} from "@/components/tools/implementations/pdf-tools";
import type { ToolRegistryItem } from "@/types/tools";

type ToolRendererProps = {
  tool: ToolRegistryItem;
};

export function ToolRenderer({ tool }: ToolRendererProps) {
  switch (tool.id) {
    case "json-formatter":
      return <JsonTool mode="format" />;
    case "json-minifier":
      return <JsonTool mode="minify" />;
    case "yaml-to-json":
      return <JsonTool mode="yaml" />;
    case "base64":
      return <Base64Tool />;
    case "html-escape":
      return <HtmlEscapeTool />;
    case "jwt-decoder":
      return <JwtDecoderTool />;
    case "uuid-generator":
      return <UuidGeneratorTool />;
    case "hash-generator":
      return <HashGeneratorTool />;
    case "password-generator":
      return <PasswordGeneratorTool />;
    case "timestamp-converter":
      return <TimestampConverterTool />;
    case "url-encoder":
      return <UrlEncoderTool />;
    case "url-parser":
      return <UrlParserTool />;
    case "curl-translator":
      return <CurlTranslatorTool />;
    case "color-converter":
      return <ColorConverterTool />;
    case "text-diff":
      return <TextDiffTool />;
    case "text-statistics":
      return <TextStatisticsTool />;
    case "slug-generator":
      return <SlugGeneratorTool />;
    case "case-converter":
      return <CaseConverterTool />;
    case "csv-to-markdown":
      return <CsvToMarkdownTool />;
    case "utm-builder":
      return <UtmBuilderTool />;
    case "meta-tag-generator":
      return <MetaTagGeneratorTool />;
    case "opengraph-preview":
      return <OpenGraphPreviewTool />;
    case "robots-generator":
      return <RobotsGeneratorTool />;
    case "image-metadata-stripper":
      return <ImageMetadataStripperTool />;
    case "image-resize":
      return <ImageResizeTool />;
    case "svg-to-image":
      return <SvgToImageTool />;
    case "pdf-merge":
      return <PdfMergeTool />;
    case "pdf-split":
      return <PdfSplitTool />;
    case "pdf-compress":
      return <PdfCompressTool />;
    case "headers-checker":
      return <HeadersCheckerTool />;
    case "redirect-chain-checker":
      return <RedirectChainCheckerTool />;
    case "security-headers-auditor":
      return <SecurityHeadersAuditorTool />;
    default:
      return <ComingSoonTool tool={tool} />;
  }
}
